import React, { Component, Fragment } from "react";
import { Element, Events, scrollSpy } from "react-scroll";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import GetDocsRight from "../components/Doctors/departments/section-left";
import GetDocsLeft from "../components/Doctors/departments/section-right";
import SEO from "../components/SEO";
import DeptList from "../components/Doctors/departments/deptListMysore";

class PageAbout extends Component {
  componentDidMount() {
    Events.scrollEvent.register("begin", function (to, element) {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register("end", function (to, element) {
      console.log("end", arguments);
    });

    scrollSpy.update();
  }

  componentWillUnmount() {
    Events.scrollEvent.remove("begin");
    Events.scrollEvent.remove("end");
  }

  handleSetActive(to) {
    console.log(to);
  }

  render() {
    return (
      <Fragment>
        <Header />
        <PageHeader
          bgImg={require("../assets/img/doctors-bg.jpg")}
          title="Our Doctors in Mysore"
          content=""
        />
        <SEO />
        <DeptList onSetActiveFunc={this.handleSetActive} />
        <Element name="obstetrics_and_gynecology" className="element">
          <GetDocsLeft
            hospitals="kcmys"
                     deptTitle="Obstetrics and Gynaecology"
            dept="obstetrics_and_gynecology"
            image="separator11.svg"
          />
        </Element>
        <Element name="paediatrics_and_neonatologist" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Pediatrics & Neonatologist"
            dept="paediatrics_and_neonatologist"
            image="separator9.svg"
          />
        </Element>
        <Element name="paediatrics_and_subspeciatilies" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Paediatric Subspecialities"
            dept="paediatrics_and_subspeciatilies"
            image="separator9.svg"
          />
        </Element>
        <Element name="developmental_pediatrics" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Developmental Paediatrics"
            dept="developmental_pediatrics"
            image="separator10.svg"
          />
        </Element>
        <Element name="fetal_medicine" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Radiology & Fetal Medicine"
            dept="fetal_medicine"
            image="separator13.svg"
          />
        </Element>
        {/* <Element name="specialists_for_mind_care" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Specialists for Psychiatric & psychological counseling"
            dept="specialists_for_mind_care"
            image="separator16.svg"
          />
        </Element> */}
        {/*

      <Element name="anaesthesia_and_critical_care" className="element">
        <GetDocsLeft
          hospitals="kcmys"
          deptTitle="Anaesthesia and Critical Care"
          dept="anaesthesia_and_critical_care"
          image="separator12.svg"
        />
      </Element>

 


      <Element name="infertility-and-ivf" className="element">
        <GetDocsLeft
          hospitals="kcmys"
          deptTitle="Fertility & IVF"
          dept="infertility_and_ivf"
          image="separator12.svg"
        />
      </Element>
*/}
        {/* <Element name="endocrinology_and_diabetology" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Endocrinology And Diabetology"
            dept="endocrinology_and_diabetology"
            image="separator15.svg"
          />
        </Element> */}
        <Element name="anaesthesia_and_critical_care" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Anaesthesia & Critical Care"
            dept="anaesthesia_and_critical_care"
            image="separator12.svg"
          />
        </Element>
        <Element name="physicians" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Physicians"
            dept="physicians"
            image="separator17.svg"
          />
        </Element>
        <Element name="pead_surgeon" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Paediatric Surgeon"
            dept="pead_surgeon"
            image="separator19.svg"
          />
        </Element>{" "}
        <Element name="surgical_specialist" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Surgical Speciality"
            dept="surgical_specialist"
            image="separator18.svg"
          />
        </Element>
        <Element name="other_specialities" className="element">
          <GetDocsLeft
            hospitals="kcmys"
            deptTitle="Other Specialities"
            dept="other_specialities"
            image="separator12.svg"
          />
        </Element>
        <Footer />
        <MobileMenu />
      </Fragment>
    );
  }
}

export default PageAbout;
